import {UFS, SPECIALTIES} from './staticVars.js'

export default {
  install (Vue) {
    Vue.mixin({
      data () {
        return {
          PLANS_DATA: {
            features: [
              'Agenda Online',
              'Prontuário Eletrônico Customizável',
              'Prescrição Digital Automatizada para Medicamentos e Exames ',
              'Certificado Digital para garantir a autenticidade dos documentos',
              'Prescrição de Atestados com tabela CID 10 ',
              'Relatórios de desempenho ',
              'Módulo Financeiro ',
              'Integração com Google Agenda ',
              'Receba mais pacientes - Integração com HealthPlace ',
              'Consultório Virtual e Atendimento via Telemedicina',
              '50% de desconto ao disponibilizar 5 horários no Marketplace'
            ],
            plans: {
              1: {
                id: 1,
                name: 'Pro',
                value: 'ROLE_PRO',
                desc: 'Gratuito e sempre será',
                price: '0,00',
                features: Array(5).fill(1)
              },
              2: {
                id: 2,
                name: 'Pro',
                value: 'ROLE_PREMIUM',
                desc: 'Não precisa de cartão de crédito',
                price: '120,00',
                features: Array(11).fill(1)
              }
            }
          },
          DRCONECTA_CONTACT_MAIL: 'contato@drconecta.com.br',
          CNPJ_MASK: '##.###.###/####-##',
          CPF_MASK: '###.###.###-###',
          MONTHS: {
            1: 'Janeiro | January',
            2: 'Fevereiro | February',
            3: 'Março | March',
            4: 'Abril | April',
            5: 'Maio | May',
            6: 'Junho | Junho',
            7: 'Julho | Julho',
            8: 'Agosto | Agosto',
            9: 'Setembro | September',
            10: 'Outubro | October',
            11: 'Novembro | November',
            12: 'Dezembro | December'
          },
          ERROR_MESSAGES: {
            required: 'Campo em branco',
            sameAsPassword: 'As senhas não conferem',
            validCep: 'CEP inválido',
            modal: {
              server: {
                title: 'Erro no servidor',
                body: 'Tente novamente mais tarde ou entre em contato com o administrador',
                size: 'md',
                active: true
              },
              form: {
                title: 'Erro no formulário',
                body: 'Confira os dados preenchidos e tente novamente.',
                size: 'md',
                active: true
              },
              authentication: {
              }
            }
          },
          UFS: UFS,
          SPECIALTIES: SPECIALTIES
        }
      }
    })
  }
}
